<template>
  <div class="about-page flex-col">
    <div class="about-page__canvas flex-col">
      <div class="about-header__panel flex-col">
        <app-header
          class="about-header__navigation"
          title="关于我们"
          :brand-icon="require('@/assets/pages/about/images/3f201f98f14c45eb5dd517f2f718c9d6.png')"
          :menu-icon="require('@/assets/pages/about/images/2bf6b6e9028792f9a40a1e65effd3981.png')"
        />
      </div>
      <div class="about-hero flex-row">
        <div class="about-hero__copy flex-col justify-between">
          <span class="about-hero__headline">兴国兴邦之本，是人才的振兴</span>
          <span class="about-hero__description">
            人工智能正重塑教育赛道，新高考改革倒逼人才
            <br />
            评价变化。青少年生涯规划，不能输在起跑线上。
          </span>
        </div>
      </div>
      <div class="about-company-overview flex-col">
        <div class="about-company-overview__heading flex-row justify-between">
          <div class="about-company-overview__heading-rule-start flex-col"></div>
          <span class="about-company-overview__title">关于智谷优学</span>
          <div class="about-company-overview__heading-rule-end flex-col"></div>
        </div>
        <span class="about-company-overview__description">
          智谷优学，源自2014年东北大学博士创业团队，专注于青
          <br />
          少年学涯成长服务。不同于传统教育机构，我们依托智谷
          <br />
          科技全产业生态，独创"产业赋能教育、高校深耕育人"的
          <br />
          差异化路径——以硬核工业智能技术为根基，联合东北大
          <br />
          学等十余所国内顶尖高校与科研机构，为青少年搭建从高
          <br />
          中选科到大学深造再到职业发展的全周期成长平台。
          <br />
          我们不仅是知识的传递者，更是成长的领航员。从高考志
          <br />
          愿的迷茫困惑，到大学深造的抉择挑战，再到职业发展的
          <br />
          方向锚定——我们以"科技+服务"为双翼，打通"学涯-职涯-
          <br />
          生涯"的全链路闭环，让每一次选择都能精准对接未来。
        </span>
        <div class="about-company-overview__statistics flex-row">
          <div class="about-company-overview__founded-stat flex-col justify-between">
            <div class="about-company-overview__founded-value">
              <span class="about-company-overview__founded-year">2014</span>
              <span class="about-company-overview__founded-value-spacer"></span>
              <span class="about-company-overview__founded-year-unit">年</span>
            </div>
            <span class="about-company-overview__founded-label">公司成立于</span>
          </div>
          <div class="about-company-overview__founded-headquarters-divider flex-col"></div>
          <div class="about-company-overview__headquarters-stat flex-col justify-between">
            <span class="about-company-overview__headquarters-city">沈阳</span>
            <span class="about-company-overview__headquarters-label">总部位于</span>
          </div>
          <div class="about-company-overview__headquarters-service-divider flex-col"></div>
          <div class="about-company-overview__service-stat flex-col justify-between">
            <div class="about-company-overview__service-value">
              <span class="about-company-overview__service-count">100,000+</span>
              <span class="about-company-overview__service-unit">人次</span>
            </div>
            <span class="about-company-overview__service-label">累计服务考生</span>
          </div>
        </div>
        <div class="about-company-overview__brand-cards flex-col">
          <div
            class="about-company-overview__brand-card flex-row"
            :style="{ background: item.backgroundColor }"
            v-for="(item, index) in brandOverviewCards"
            :key="index"
          >
            <img class="about-company-overview__brand-card-icon" referrerpolicy="no-referrer" :src="item.icon" />
            <div class="about-company-overview__brand-card-copy flex-col justify-between">
              <span class="about-company-overview__brand-card-title">{{ item.title }}</span>
              <span class="about-company-overview__brand-card-description">{{ item.description }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="about-ecosystem flex-col">
        <div class="about-ecosystem__heading flex-row">
          <div class="about-ecosystem__heading-rule-start flex-col"></div>
          <span class="about-ecosystem__title">三擎驱动&nbsp;·&nbsp;构建全链路教育生态</span>
          <div class="about-ecosystem__heading-rule-end flex-col"></div>
        </div>
        <span class="about-ecosystem__description">
          聚焦前沿智能技术，联合大学共建研发基地，
          <br />
          打造“产、学、研、用”深度融合的科技创新平台，
          <br />
          形成“工业智能产品、新工科专业升级、人工智能科普”
          <br />
          三大业务板块。
        </span>
        <div class="about-ecosystem__pillars flex-col justify-between">
          <div class="about-ecosystem__industry-pillar flex-col">
            <div class="about-ecosystem__industry-brand flex-col"><span class="about-ecosystem__industry-brand-name">智谷工业</span></div>
            <div class="about-ecosystem__industry-copy flex-col justify-between">
              <span class="about-ecosystem__industry-title">产&nbsp;·&nbsp;产业之基</span>
              <span class="about-ecosystem__industry-description">
                聚焦小场景智能化、关键环节无人化，自研智能解决方
                <br />
                案，赋能工业生产转型升级
              </span>
            </div>
            <div class="about-ecosystem__industry-research flex-col">
              <span class="about-ecosystem__industry-research-caption">围绕“863计划重点研发课题”</span>
              <span class="about-ecosystem__industry-research-title">海洋油气能源运输管道寿命预测关键技术</span>
              <div class="about-ecosystem__industry-metric-divider-top flex-col"></div>
              <div class="about-ecosystem__industry-funding-metric flex-col justify-between">
                <div class="about-ecosystem__industry-funding-value">
                  <span class="about-ecosystem__industry-funding-count">5000</span>
                  <span class="about-ecosystem__industry-funding-unit">万</span>
                </div>
                <span class="about-ecosystem__industry-funding-label">科研经费</span>
              </div>
              <div class="about-ecosystem__industry-commercialization-metric flex-col justify-between">
                <div class="about-ecosystem__industry-commercialization-value">
                  <span class="about-ecosystem__industry-commercialization-count">1060</span>
                  <span class="about-ecosystem__industry-commercialization-unit">万</span>
                </div>
                <span class="about-ecosystem__industry-commercialization-label">成果转化</span>
              </div>
              <div class="about-ecosystem__industry-experience-metric flex-col justify-between">
                <div class="about-ecosystem__industry-experience-value">
                  <span class="about-ecosystem__industry-experience-count">15</span>
                  <span class="about-ecosystem__industry-experience-unit">年</span>
                </div>
                <span class="about-ecosystem__industry-experience-label">研究经验</span>
              </div>
              <div class="about-ecosystem__industry-metric-divider-middle flex-col"></div>
              <div class="about-ecosystem__industry-patent-metric flex-col justify-between">
                <div class="about-ecosystem__industry-patent-value">
                  <span class="about-ecosystem__industry-patent-count">102</span>
                  <span class="about-ecosystem__industry-patent-unit">项</span>
                </div>
                <span class="about-ecosystem__industry-patent-label">申请专利</span>
              </div>
              <div class="about-ecosystem__industry-paper-metric flex-col justify-between">
                <div class="about-ecosystem__industry-paper-value">
                  <span class="about-ecosystem__industry-paper-count">100</span>
                  <span class="about-ecosystem__industry-paper-unit">+篇</span>
                </div>
                <span class="about-ecosystem__industry-paper-label">发表论文</span>
              </div>
              <div class="about-ecosystem__industry-indexed-paper-metric flex-col justify-between">
                <div class="about-ecosystem__industry-indexed-paper-value">
                  <span class="about-ecosystem__industry-indexed-paper-count">50</span>
                  <span class="about-ecosystem__industry-indexed-paper-unit">+篇</span>
                </div>
                <span class="about-ecosystem__industry-indexed-paper-label">SCII收录</span>
              </div>
              <div class="about-ecosystem__industry-metric-divider-bottom flex-col"></div>
            </div>
          </div>
          <div class="about-ecosystem__education-pillar flex-col">
            <div class="about-ecosystem__education-brand flex-col"><span class="about-ecosystem__education-brand-name">智谷教育</span></div>
            <span class="about-ecosystem__education-title">学&nbsp;·&nbsp;学术之魂</span>
            <span class="about-ecosystem__education-description">
              深度融合产业场景与教学实践，助力高校培养复合型
              <br />
              人才
            </span>
            <div class="about-ecosystem__education-teaching-card flex-row">
              <div class="about-ecosystem__education-teaching-card-content flex-row justify-between">
                <img
                  class="about-ecosystem__education-teaching-card-image"
                  referrerpolicy="no-referrer"
                  src="@/assets/pages/about/images/b2d4b6babc651e696e705e154dad4969.png"
                />
                <div class="about-ecosystem__education-teaching-card-copy flex-col justify-between">
                  <span class="about-ecosystem__education-teaching-card-title">高校场景化科教融合</span>
                  <span class="about-ecosystem__education-teaching-card-description">
                    案例涵盖：东北大学、大连理工大学、
                    <br />
                    辽宁科技大学、辽宁石油化工大学...
                  </span>
                </div>
              </div>
            </div>
            <div class="about-ecosystem__education-competition-card flex-row">
              <div class="about-ecosystem__education-competition-card-content flex-row justify-between">
                <img
                  class="about-ecosystem__education-competition-card-image"
                  referrerpolicy="no-referrer"
                  src="@/assets/pages/about/images/d1af359a3070e70eb1e5df2384f9cc00.png"
                />
                <div class="about-ecosystem__education-competition-card-copy flex-col justify-between">
                  <span class="about-ecosystem__education-competition-card-title">新工科赛事服务</span>
                  <span class="about-ecosystem__education-competition-card-description">
                    竞赛涵盖：睿杭机器人开发者大赛、
                    <br />
                    中国机器人及人工智能大赛...
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="about-ecosystem__learning-pillar flex-col">
            <div class="about-ecosystem__learning-brand flex-col"><span class="about-ecosystem__learning-brand-name">智谷优学</span></div>
            <div class="about-ecosystem__learning-copy flex-col justify-between">
              <span class="about-ecosystem__learning-title">研、用&nbsp;·&nbsp;应用之本</span>
              <span class="about-ecosystem__learning-description">
                聚焦青少年学涯阶段，从高中到大学，提供全周期
                <br />
                升学服务
              </span>
            </div>
            <div class="about-ecosystem__learning-network flex-col">
              <span class="about-ecosystem__learning-network-title">1运营中心&nbsp;+&nbsp;1研发中心&nbsp;+&nbsp;N大学基地</span>
              <span class="about-ecosystem__learning-network-description">依托区域重大学，聚合生态资源</span>
              <div class="about-ecosystem__learning-partner flex-col justify-between">
                <span class="about-ecosystem__learning-partner-name">东北大学出版社</span>
                <span class="about-ecosystem__learning-partner-label">战略合作</span>
              </div>
              <div class="about-ecosystem__learning-metrics flex-row justify-between">
                <div class="about-ecosystem__learning-institution-metric flex-col justify-between">
                  <div class="about-ecosystem__learning-institution-value">
                    <span class="about-ecosystem__learning-institution-count">100</span>
                    <span class="about-ecosystem__learning-institution-unit">+</span>
                  </div>
                  <span class="about-ecosystem__learning-institution-label">合作机构</span>
                </div>
                <div class="about-ecosystem__institution-teacher-divider flex-col"></div>
                <div class="about-ecosystem__learning-teacher-metric flex-col justify-between">
                  <div class="about-ecosystem__learning-teacher-value">
                    <span class="about-ecosystem__learning-teacher-count">315</span>
                    <span class="about-ecosystem__learning-teacher-unit">名</span>
                  </div>
                  <span class="about-ecosystem__learning-teacher-label">填报老师</span>
                </div>
                <div class="about-ecosystem__teacher-expert-divider flex-col"></div>
                <div class="about-ecosystem__learning-expert-metric flex-col justify-between">
                  <div class="about-ecosystem__learning-expert-value">
                    <span class="about-ecosystem__learning-expert-count">10</span>
                    <span class="about-ecosystem__learning-expert-unit">+</span>
                  </div>
                  <span class="about-ecosystem__learning-expert-label">专家教授</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="about-milestones flex-col">
        <div class="about-milestones__heading flex-row justify-between">
          <div class="about-milestones__heading-rule-start flex-col"></div>
          <span class="about-milestones__title">十年深耕，链接学术和产业</span>
          <div class="about-milestones__heading-rule-end flex-col"></div>
        </div>
        <div
          ref="milestoneScroller"
          class="about-milestones__scroll"
          role="region"
          aria-label="公司发展历程"
          tabindex="0"
          @scroll.passive="updateMilestoneProgress"
        >
          <div class="about-milestones__track">
            <article
              v-for="milestone in companyMilestones"
              :key="milestone.year"
              class="about-milestones__card"
            >
              <div class="about-milestones__card-content">
                <h3 class="about-milestones__card-title">{{ milestone.title }}</h3>
                <p v-if="milestone.description" class="about-milestones__card-description">
                  {{ milestone.description }}
                </p>
                <ul class="about-milestones__detail-list">
                  <li
                    v-for="detail in milestone.details"
                    :key="detail"
                    class="about-milestones__detail"
                  >
                    {{ detail }}
                  </li>
                </ul>
              </div>
              <div class="about-milestones__year-row">
                <span class="about-milestones__year">{{ milestone.year }}</span>
              </div>
            </article>
          </div>
        </div>
        <div class="about-milestones__progress" aria-hidden="true">
          <span
            class="about-milestones__progress-thumb"
            :style="{
              left: `${milestoneScrollProgress}%`,
              width: `${milestoneProgressWidth}%`
            }"
          ></span>
        </div>
      </div>
      <div class="about-honors flex-col">
        <div class="about-honors__heading flex-row">
          <div class="about-honors__heading-rule-start flex-col"></div>
          <span class="about-honors__title">荣誉资质</span>
          <div class="about-honors__heading-rule-end flex-col"></div>
        </div>
        <span class="about-honors__description">
          公司以大学基地建设为载体，
          <br />
          围绕新工科方向研发系列具有自主知识产权的核心产品，
          <br />
          目前是国家高新技术企业、省级专精特新企业，
          <br />
          屡次获得省部级科技进步奖项，承接国家级重点科研项目。
        </span>
        <div class="about-honors__scroll" aria-label="荣誉资质证书">
          <div class="about-honors__track">
            <figure
              v-for="honor in honorCertificates"
              :key="honor.title"
              class="about-honors__card"
            >
              <div class="about-honors__image-frame">
                <img
                  class="about-honors__image"
                  referrerpolicy="no-referrer"
                  :src="honor.image"
                  :alt="honor.title"
                />
              </div>
              <figcaption class="about-honors__card-title">{{ honor.title }}</figcaption>
            </figure>
          </div>
        </div>
      </div>
      <div class="about-advantages flex-col">
        <div class="about-advantages__heading flex-row">
          <div class="about-advantages__heading-rule-start flex-col"></div>
          <span class="about-advantages__title">核心优势，权威背书</span>
          <div class="about-advantages__heading-rule-end flex-col"></div>
        </div>
        <span class="about-advantages__subtitle">名校背书+本土深耕，全国资源+产学研落地</span>
        <div class="about-advantages__card-list flex-col">
          <div
            class="about-advantages__card flex-col"
            :style="{ background: item.backgroundImage }"
            v-for="(item, index) in competitiveAdvantages"
            :key="index"
          >
            <div class="about-advantages__card-title-row flex-row"><span class="about-advantages__card-title">{{ item.title }}</span></div>
            <div class="about-advantages__card-body flex-row justify-between">
              <img class="about-advantages__card-icon" referrerpolicy="no-referrer" :src="item.icon" />
              <span class="about-advantages__card-description">{{ item.description }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="about-social-responsibility flex-col">
        <div class="about-social-responsibility__heading flex-row">
          <div class="about-social-responsibility__heading-rule-start flex-col"></div>
          <span class="about-social-responsibility__title">社会责任</span>
          <div class="about-social-responsibility__heading-rule-end flex-col"></div>
        </div>
        <span class="about-social-responsibility__community-name">聚星社区</span>
        <span class="about-social-responsibility__tagline">以公益之心，照亮学子成长之路</span>
        <span class="about-social-responsibility__description">
          汇聚顶尖高校资源，链接企业，通过免费资料、营地实践、
          <br />
          实习对接等免费服务，让大学生走好每一步
        </span>
        <div class="about-social-responsibility__benefits-top flex-row">
          <div class="about-social-responsibility__learning-benefit flex-col">
            <img
              class="about-social-responsibility__learning-benefit-image"
              referrerpolicy="no-referrer"
              src="@/assets/pages/about/images/42563f3f392eefb12bbeee2574f846ad.png"
            />
            <span class="about-social-responsibility__learning-benefit-label">免费学习资料</span>
          </div>
          <div class="about-social-responsibility__internship-benefit flex-col">
            <img
              class="about-social-responsibility__internship-benefit-image"
              referrerpolicy="no-referrer"
              src="@/assets/pages/about/images/e1a6e435faf0098e4e6929e946bb85eb.png"
            />
            <span class="about-social-responsibility__internship-benefit-label">实习岗位对接</span>
          </div>
        </div>
        <div class="about-social-responsibility__benefits-bottom flex-row justify-between">
          <div class="about-social-responsibility__club-benefit flex-col">
            <img
              class="about-social-responsibility__club-benefit-image"
              referrerpolicy="no-referrer"
              src="@/assets/pages/about/images/98bcf3fbd8ba25499a819330be1134d6.png"
            />
            <span class="about-social-responsibility__club-benefit-label">大学社团活动</span>
          </div>
          <div class="about-social-responsibility__training-benefit flex-col">
            <img
              class="about-social-responsibility__training-benefit-image"
              referrerpolicy="no-referrer"
              src="@/assets/pages/about/images/8d7ca78f1824624fb5ed90bf5f7df6d0.png"
            />
            <span class="about-social-responsibility__training-benefit-label">企业定向培养</span>
          </div>
        </div>
        <button class="about-social-responsibility__explore-button flex-col" @click="openContact"><span class="about-social-responsibility__explore-button-label">立即探索</span></button>
      </div>
      <div class="about-contact-intro flex-col">
        <div class="about-contact-intro__heading flex-row">
          <div class="about-contact-intro__heading-rule-start flex-col"></div>
          <span class="about-contact-intro__title">联系我们</span>
          <div class="about-contact-intro__heading-rule-end flex-col"></div>
        </div>
        <span class="about-contact-intro__description">有任何问题或合作意向，欢迎随时联系我们</span>
      </div>
      <div class="about-product-contact flex-col">
        <div class="about-product-contact__heading flex-col"><span class="about-product-contact__title">产品咨询</span></div>
        <span class="about-product-contact__audience-prompt">如果您是家长/学生，想要：</span>
        <div class="about-product-contact__consultation-university-options flex-row justify-between">
          <div class="about-product-contact__consultation-option flex-col"><span class="about-product-contact__consultation-option-label">产品咨询与预约</span></div>
          <div class="about-product-contact__university-option flex-col"><span class="about-product-contact__university-option-label">大学服务咨询</span></div>
        </div>
        <div class="about-product-contact__camp-community-options flex-row justify-between">
          <div class="about-product-contact__camp-option flex-col"><span class="about-product-contact__camp-option-label">营地报名预约</span></div>
          <div class="about-product-contact__community-option flex-col"><span class="about-product-contact__community-option-label">了解/加入聚星社区</span></div>
        </div>
        <span class="about-product-contact__contact-prompt">请联系：</span>
        <div class="about-product-contact__contact-details flex-row">
          <div class="about-product-contact__contact-copy">
            <span class="about-product-contact__contact-person">
              时老师
              <br />
            </span>
            <span class="about-product-contact__phone-label">手机号：</span>
            <span class="about-product-contact__phone-number">
              18525123266
              <br />
            </span>
            <span class="about-product-contact__hours">工作日：9:00~18:00</span>
          </div>
          <div class="about-product-contact__wechat-card flex-col justify-between">
            <img
              class="about-product-contact__wechat-qr"
              referrerpolicy="no-referrer"
              src="@/assets/pages/about/images/4f372c6545e6176b128ccf3da75a013b.png"
            />
            <span class="about-product-contact__wechat-label">扫码添加微信</span>
          </div>
        </div>
      </div>
      <div class="about-business-contact flex-col">
        <div class="about-business-contact__heading flex-col"><span class="about-business-contact__title">商务合作</span></div>
        <span class="about-business-contact__audience-prompt">如果您是机构/企业/高校，想要：</span>
        <div class="about-business-contact__institution-empowerment-options flex-row justify-between">
          <div class="about-business-contact__institution-option flex-col"><span class="about-business-contact__institution-option-label">机构合作对接</span></div>
          <div class="about-business-contact__empowerment-option flex-col"><span class="about-business-contact__empowerment-option-label">赋能聚星计划</span></div>
        </div>
        <div class="about-business-contact__talent-cooperation-options flex-row justify-between">
          <div class="about-business-contact__talent-option flex-col"><span class="about-business-contact__talent-option-label">获得定向培养人才</span></div>
          <div class="about-business-contact__cooperation-option flex-col"><span class="about-business-contact__cooperation-option-label">商务合作/洽谈</span></div>
        </div>
        <span class="about-business-contact__contact-prompt">请联系：</span>
        <div class="about-business-contact__contact-details flex-row">
          <div class="about-business-contact__contact-copy">
            <span class="about-business-contact__contact-person">
              刘老师
              <br />
            </span>
            <span class="about-business-contact__phone-label">手机号：</span>
            <span class="about-business-contact__phone-number">
              18640109087
              <br />
            </span>
            <span class="about-business-contact__hours">工作日：9:00~18:00</span>
          </div>
          <div class="about-business-contact__wechat-card flex-col justify-between">
            <img
              class="about-business-contact__wechat-qr"
              referrerpolicy="no-referrer"
              src="@/assets/pages/contact/images/liu-teacher-wechat-qr.png"
              alt="刘老师微信二维码"
            />
            <span class="about-business-contact__wechat-label">扫码添加微信</span>
          </div>
        </div>
      </div>
      <div class="about-footer flex-col justify-end">
        <div class="about-footer__location-panel flex-col">
          <div class="about-footer__headquarters flex-row">
            <div class="about-footer__headquarters-copy-panel flex-col">
              <div class="about-footer__headquarters-copy">
                <span class="about-footer__headquarters-name">
                  沈阳总部
                  <br />
                </span>
                <span class="about-footer__headquarters-address">
                  辽宁省沈阳市和平区新世界丰盛商务
                  <br />
                  大厦1802室
                </span>
              </div>
            </div>
            <div class="about-footer__map-pin flex-col">
              <img
                class="about-footer__map-pin-image"
                referrerpolicy="no-referrer"
                src="@/assets/pages/about/images/e1dcfa5b35ffcea158147ce40904aa48.png"
                alt="沈阳总部位置"
              />
            </div>
          </div>
          <div class="about-footer__map-decoration flex-row">
            <div class="about-footer__map-decoration-image flex-col">
              <img
                class="about-footer__map-decoration-asset"
                referrerpolicy="no-referrer"
                src="@/assets/pages/about/images/87a7c9023fd8bdd486a39b03d3db882e.png"
              />
            </div>
          </div>
        </div>
        <app-footer />
      </div>
      <app-floating-actions ref="floatingActions" />
    </div>
  </div>
</template>
<script>
import AppFloatingActions from '@/components/actions/AppFloatingActions.vue'
import AppFooter from '@/components/layout/AppFooter.vue'
import AppHeader from '@/components/navigation/AppHeader.vue'

export default {
  name: 'AboutView',
  components: { AppFloatingActions, AppFooter, AppHeader },
  data() {
    return {
      milestoneScrollProgress: 0,
      milestoneProgressWidth: 20,
      brandOverviewCards: [
        {
          backgroundColor: 'rgba(63,107,205,1.000000)',
          icon: require('@/assets/pages/about/images/remote/d4162ed503e18ac0acae656163fde7a6.png'),
          title: '品牌定位',
          description: '辽宁本土发源、全国覆盖的青少年学涯成长领航者'
        },
        {
          backgroundColor: 'rgba(15,143,203,1.000000)',
          icon: require('@/assets/pages/about/images/remote/1d79c276a98e4369f80906a7753e46ca.png'),
          title: '愿景使命',
          description: '成为全国领先的青少年学涯成长领航者，构建从高中到大学的全阶段科学发展生态系统'
        }
      ],
      companyMilestones: [
        {
          year: '2014',
          title: '正式起航',
          description: '',
          details: ['孵化于东北大学，博士团队创立', '确立人工智能+产学研融合作为核心方向']
        },
        {
          year: '2015',
          title: '平台发布',
          description: '立足辽宁开发专属系统，发布旗舰产品“东大一帆”学涯规划平台，为省内数百名填报老师、10余万考生深度赋能。',
          details: ['填报师系统', '志愿小程序', '大学规划系统']
        },
        {
          year: '2018',
          title: '人工智能',
          description: '进军工业领域，联合东北大学参与国家863重点研发攻关，研制管道智能检测平台，实现国产化替代。',
          details: ['荣获国家科技进步二等奖', '日内瓦国际金奖', '省部级自然科学奖3项', '辽宁省科技进步二等奖', '中国专利发明奖']
        },
        {
          year: '2021',
          title: '产业深耕',
          description: '获批成立辽宁省工业智能技术产业研究院，通过人才引进落地浙江分公司，拓展全国工业无损智能检测业务。',
          details: ['莫干山全球创业大赛二等奖', '入选南太湖精英计划', '系统落地13000公里管道']
        },
        {
          year: '2023',
          title: '多元布局',
          description: '聚焦“小场景智能化、关键环节无人化”，以智能产品和解决方案赋能工业生产转型升级。',
          details: ['启动智慧矿山业务', '入选国家管网储运技术核心供应商']
        },
        {
          year: '2024',
          title: '大学教育',
          description: '融合真实产业场景与教学实践，构建智慧化教学解决方案，助力高校培养复合型科技人才。',
          details: ['研发本科教学产品', '承接多项省部级重大科研专项', '覆盖多所国内重点高校']
        },
        {
          year: '2025',
          title: '生态融合',
          description: '成立东北大学—智谷工业智能研究中心，开展前沿技术研发和核心基础能力建设。',
          details: ['推出智谷优学品牌', '构建三大核心业务矩阵']
        },
        {
          year: '2026',
          title: '生态升级',
          description: '',
          details: ['成立青少年学涯专委会', '建设东北大学研究生联合培养基地', '建立东北大学出版社融合实验室']
        }
      ],
      honorCertificates: [
        {
          image: require('@/assets/pages/about/jz/国家高新技术企业.jpg'),
          title: '国家高新技术企业'
        },
        {
          image: require('@/assets/pages/about/jz/双软认证企业.jpg'),
          title: '双软认证企业'
        },
        {
          image: require('@/assets/pages/about/jz/省级专精特精企业.png'),
          title: '省级专精特新企业'
        },
        {
          image: require('@/assets/pages/about/jz/省人工智能理事但闻.jpg'),
          title: '省人工智能理事单位'
        },
        {
          image: require('@/assets/pages/about/jz/省部级科技进步奖.jpg'),
          title: '省部级科技进步奖'
        }
      ],
      competitiveAdvantages: [
        {
          backgroundImage: `url(${require('@/assets/pages/about/images/remote/35b8cf9e4757a0507721a79a3d565f13.png')}) 100% no-repeat`,
          title: '本土发源立根，全国覆盖拓局',
          icon: require('@/assets/pages/about/images/remote/609ab93b9df2041f0a4e2c34e2806df3.png'),
          description: '深耕辽宁本土学情考情，熟知新高考政策与录取规则；同时打通全国高校、科研机构链路，实现本土精细化与全国资源化的双向融合。'
        },
        {
          backgroundImage: `url(${require('@/assets/pages/about/images/remote/48226ccec543d8e2490850f4d750179d.png')}) 0px -1px no-repeat`,
          title: '顶尖资源背书，专业性拉满',
          icon: require('@/assets/pages/about/images/remote/c6bb8ec4ce9bb7eee59fb54a8f391d07.png'),
          description: '依托东北大学、大连理工等本土985高校，联动清华、北大、中科院等全国平台，汇聚专家、高校导师、博士研发团队，资源硬核、服务专业。'
        },
        {
          backgroundImage: `url(${require('@/assets/pages/about/images/remote/c89c13a9330b34eec5840ea5d5fd275d.png')}) 0px -1px no-repeat`,
          title: '全周期覆盖，产品体系完善',
          icon: require('@/assets/pages/about/images/remote/a790dce37c334f3044db54a4d21cd6f1.png'),
          description: '覆盖高中规划、高考填报，到准大学过渡衔接，再到大学深造提升，全周期产品无断层；同时满足C端学子与B端合作机构需求。'
        },
        {
          backgroundImage: `url(${require('@/assets/pages/about/images/remote/b8f8d4be1acf00ed5681efe760bc1108.png')}) 100% no-repeat`,
          title: '科技+实践结合，本土+全国双适配',
          icon: require('@/assets/pages/about/images/remote/deb4c6c47985187ff65137c2224c1f87.png'),
          description: '自研多款智能小程序，用科技提升服务效率；搭配线下营地实践、一对一学术指导，理论与实操深度结合，服务落地有效果。'
        }
      ]
    };
  },
  mounted() {
    this.$nextTick(this.updateMilestoneProgress)
    window.addEventListener('resize', this.updateMilestoneProgress)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateMilestoneProgress)
  },
  methods: {
    updateMilestoneProgress() {
      const scroller = this.$refs.milestoneScroller

      if (!scroller || scroller.scrollWidth === 0) {
        return
      }

      const maximumScroll = scroller.scrollWidth - scroller.clientWidth
      const visibleRatio = Math.min(1, scroller.clientWidth / scroller.scrollWidth)
      const scrollRatio = maximumScroll > 0 ? scroller.scrollLeft / maximumScroll : 0

      this.milestoneProgressWidth = visibleRatio * 100
      this.milestoneScrollProgress = scrollRatio * (100 - this.milestoneProgressWidth)
    },
    openContact() {
      if (this.$refs.floatingActions) {
        this.$refs.floatingActions.openContact()
      }
    }
  }
};
</script>
<style scoped lang="css" src="@/assets/pages/about/styles/index.response.css" />
